import { render, staticRenderFns } from "./AssetCerts.vue?vue&type=template&id=76992f32&scoped=true&"
import script from "./AssetCerts.vue?vue&type=script&lang=ts&"
export * from "./AssetCerts.vue?vue&type=script&lang=ts&"
import style0 from "./AssetCerts.vue?vue&type=style&index=0&id=76992f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76992f32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
